export default "__VITE_ASSET__CliuWSaR__"